import React, { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'

class RootErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, errorInfo) {
    console.error("REACT_RENDER_CRASH:", error, errorInfo);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 24, background: '#0a0f1d', color: '#f87171', fontFamily: 'monospace', minHeight: '100vh', zIndex: 999999 }}>
          <h2 style={{ fontSize: '20px', color: '#fbbf24', marginBottom: '12px' }}>Platformani yuklashda xatolik yuz berdi:</h2>
          <p style={{ color: '#e2e8f0', marginBottom: '16px' }}>{this.state.error?.message || String(this.state.error)}</p>
          <pre style={{ background: '#030712', padding: '16px', borderRadius: '8px', overflowX: 'auto', fontSize: '12px' }}>
            {this.state.error?.stack}
          </pre>
          <button 
            onClick={() => window.location.reload()}
            style={{ marginTop: '16px', padding: '8px 16px', background: '#c59b27', color: '#000', fontWeight: 'bold', borderRadius: '6px', border: 'none', cursor: 'pointer' }}
          >
            Sahifani yangilash
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

try {
  const rootEl = document.getElementById('root');
  if (rootEl) {
    const root = createRoot(rootEl);
    root.render(
      <StrictMode>
        <RootErrorBoundary>
          <App />
        </RootErrorBoundary>
      </StrictMode>
    );
  } else {
    console.error("FATAL: #root element not found in DOM");
  }
} catch (e) {
  console.error("ROOT_INIT_EXCEPTION:", e);
}
